import { toApiDate } from '@/utils/formatters'
import type { ReportFilters } from '@/modules/reportTemplates/api'

/** Mirrors the NS register request, without its page size or cursor. */
export function adverseReportFilters(filters: Record<string, unknown>): ReportFilters {
  const result: ReportFilters = {}
  for (const key of ['departments', 'event_types', 'numbers', 'coordinators', 'creators', 'status', 'risk']) {
    const value = filters[key]
    if (Array.isArray(value) && value.length)
      result[key === 'risk' ? 'risk_level' : key] = value.join(',')
  }
  for (const key of ['created_after', 'created_before']) {
    const value = filters[key]
    if (value instanceof Date || typeof value === 'string') {
      const date = toApiDate(value)
      if (date)
        result[key] = date
    }
  }
  if (typeof filters.search === 'string' && filters.search)
    result.search = filters.search
  for (const key of ['is_active', 'requires_action', 'is_actual']) {
    if (typeof filters[key] === 'boolean')
      result[key] = filters[key]
  }

  if (typeof filters.advanced === 'string' && filters.advanced)
    result.advanced = filters.advanced

  return result
}
